import { styled, Image, colors } from '../../styles/base/_allBase.styles'

export const SectionContainer = styled.div`
  width:min(118rem, calc(100% - 4rem)); margin:0 auto; padding:1rem 0 3rem;
  display:grid; grid-template-columns:repeat(4,minmax(0,1fr)); gap:2rem;
  > h2 {grid-column:1/-1; font:700 clamp(2.6rem,3vw,3.6rem)/1.2 'Whyte-Bold',sans-serif; color:${colors.warmPalette.primaryDark}; margin:0 0 1rem;}
  @media(max-width:767px){width:min(100% - 2.4rem, 60rem); grid-template-columns:1fr; gap:1.2rem; padding:3rem 0 5rem;}
`
export const Card = styled.div`
  position:relative; min-height:28rem; overflow:hidden; border-radius:.8rem; isolation:isolate;
  grid-column:span 1;
  box-shadow:0 1.2rem 3.4rem rgba(24,47,53,.12);
  &:hover img{transform:scale(1.035);} &:hover div:last-child{transform:translateY(-.4rem);}
  @media(max-width:767px){grid-column:1; min-height:21rem;}
`
export const CardImage = styled(Image)`object-fit:cover; transition:transform .5s ease; z-index:-2;`
export const CardOverlay = styled.div`position:absolute; inset:0; z-index:-1; background:linear-gradient(180deg,rgba(24,47,53,.03) 35%,rgba(24,47,53,.82) 100%);`
export const CardTitle = styled.div`
  position:absolute; left:clamp(1.8rem,3vw,3rem); right:2rem; bottom:clamp(1.8rem,3vw,3rem); color:white; transition:transform .25s ease;
  &::before{content:'';display:block;width:4.8rem;height:3px;margin-bottom:1.2rem;background:${colors.brandPalette.brass};}
  h3,h4,h5{margin:0;color:white!important;font-family:'Whyte-Bold',sans-serif;font-size:clamp(2rem,2.2vw,3rem);font-weight:700;letter-spacing:-.01em;}
`
